import { EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { isEmpty } from 'lodash';
import { merge } from 'rxjs';
var TabSettingsComponent = /** @class */ (function () {
    function TabSettingsComponent(fb) {
        this.fb = fb;
        this.noMaintenancesSelectedChange = new EventEmitter();
        this.noMaintenanceTypesSelected = false;
        this.requiredMark = true;
    }
    TabSettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.segmentsSettingsForm = this.fb.group({
            linkMaintenanceTypesToSegment: [false],
        });
        if (this.segment && !isEmpty(this.segment.maintenanceTypes)) {
            this.segmentsSettingsForm.controls.linkMaintenanceTypesToSegment.setValue(true);
        }
        merge(this.segmentsSettingsForm.get('linkMaintenanceTypesToSegment').valueChanges, this.maintenanceTypesForm.get('maintenanceTypes').valueChanges).subscribe(function () {
            var linkMaintenanceTypesValue = _this.segmentsSettingsForm.get('linkMaintenanceTypesToSegment').value;
            var maintenanceTypesValue = _this.maintenanceTypesForm.get('maintenanceTypes').value;
            _this.noMaintenanceTypesSelected = linkMaintenanceTypesValue && !maintenanceTypesValue;
            _this.noMaintenancesSelectedChange.emit(_this.noMaintenanceTypesSelected);
        });
    };
    return TabSettingsComponent;
}());
export { TabSettingsComponent };
